import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  height: calc(100vh - 80px);
  grid-template-columns: 100%;
  // grid-template-rows: 85% 15%;
  grid-template-rows: ${(props) => (props.isExport ? "100%" : "85% 15%;")};
  gap: 0px 0px;
  grid-template-areas:
    ". ."
    ". .";

  @media only screen and (min-width: 867px) {
    display: grid;
    height: 100vh;
    grid-template-columns: 100%;
    grid-template-rows: ${(props) =>
      props.isExport ? "100%" : "calc(90% - 50px) 10%;"};
    gap: 0px 0px;
    grid-template-areas:
      ". ."
      ". .";

    canvas {
      display: flex;
      background: url("/assets/court-backgorund.jpg");
      background-size: cover;
      background-repeat: no-repeat;
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100%;
      .court-img {
        display: none;
      }
      .court-img-m {
        width: 100%;
        //transform: rotate(180deg);
      }
    }
  }
`;
export const Court = styled.div`
  display: flex;
  background: url("/assets/court-backgorund.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  width: 100vw;
  .court-img {
    display: none;
  }
  .court-img-m {
    width: 100vw;
  }
  height: ${(props) => (props.isExport ? "100%" : "auto")};
  @media only screen and (min-width: 867px) {
    .court-img-m {
      display: none;
    }
    .court-img {
      display: block;
      width: 100%;
    }
  }
`;

export const Navbar = styled.nav`
  width: 100vw;
  height: 80px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #2a2a2a;
  color: #fff;
  .back-arrow-container {
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    padding: 0 2%;
    transform: rotate(90deg);
    cursor: pointer;
    img {
      width: 4%;
      margin-left: 3%;
    }
    a {
      width: 50%;
      img {
        width: 60%;
        margin-left: 15%;
      }
    }
    h1 {
      margin: 0;
      font-size: 16px;
    }
    p {
      margin: 0;
    }
  }
  .download_button-container {
    height: fit-content;
    width: 80px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    padding: 0 2%;
    transform: rotate(90deg);
    cursor: pointer;
    .download_button {
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: auto;
      padding: 0 2%;
      transform: rotate(0deg);
      cursor: pointer;
      width: 20%;
      img {
        width: 100%;
      }
    }
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
    img {
      width: fit-content;
    }
  }
  &.hide {
    display: none;
  }
  @media only screen and (min-width: 867px) {
    height: 50px;
    display: grid;
    grid-template-columns: 50% 50%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    .back-arrow-container {
      transform: inherit;
      flex-direction: row;
      h1 {
        font-size: 20px;
      }
      a {
        width: 100%;
      }
    }
    .download_button-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      transform: rotate(0deg);
      padding: 0;
      margin-right: 2rem;
      p {
        margin: 0;
      }
    }
  }
`;

export const SectorNav = styled.div`
  display: flex;
  flex-direction: row;
  width: 20%;
  a {
    width: 100%;
    height: 100%;
  }
  p {
    width: auto;
    height: fit-content;
    margin: 0;
  }
`;
export const Sidebar = styled.div`
  background-color: #2a2a2a;
  width: 100%;
  height: auto;
  padding: 0 3% 0 3%;
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    width: 100%;
    height: 10%;
    border: 2px solid;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    width: fit-content;
    height: fit-content;
    margin: 5% 0;
  }
  h1 {
    color: #ccc;
    font-size: 20px;
    font-family: "Comic Neue Bold";
  }
  p {
    color: #fff;
    font-size: 16px;
    font-family: "Comic Neue Bold";
  }
`;

export const Title = ({ children, ...props }) => <h1 {...props}>{children}</h1>;
export const AnimatorBar = styled.div`
  //display: grid;
  grid-template-columns: 15% 10% 10% 10% 10% 20% auto;
  display: flex;
  color: #fff;
  background-color: black;
  .controls {
    display: none;
  }
  .nameText {
    flex-basis: 60%;
  }
  //  position: ${(props) => (props.isExport ? "absolute" : "flex")};
  #positions-container {
    width: 100%;
    overflow: scroll;
    background-color: transparent;
    display: flex;
    justify-content: flex-start;
    &::-webkit-scrollbar {
      display: none;
    }
    .positionNumber {
      width: 50px;
      max-width: 50px;
      min-width: 50px;
      height: 100%;
      background-color: #2a2a2a;
      margin: 0 1px 0 1px;
      text-align: center;
      img {
        width: 60%;
        margin: auto;
      }
    }
    img {
      width: 60%;
    }
  }
  .lastContainers {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 70%;
    }
  }
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    transform: rotate(90deg);
    margin: 0;
  }
  .loop-active {
    border: 2px solid green;
    opacity: 1;
  }
  .loop-unactive {
    background-color: #2a2a2a;
    opacity: 0.5;
  }
  &.hide {
    display: none;
  }
  @media only screen and (min-width: 867px) {
    grid-template-columns: 8% 4% 4% 4% 4% 10% auto;
    .controls {
      display: flex;
      flex-basis: 10%;
    }
    p {
      transform: inherit;
    }
  }
`;

export const Square = styled.div`
  width: 100px;
  height: 100px;
  border: 2px solid red;
  overflow: auto;
  //resize: both;
  .tr-transform__rotator:hover,
  .tr-transform__scale-point:hover {
    background: #f1f5f8;
  }
  .tr-transform__rotator:active,
  .tr-transform__scale-point:active {
    background: #dae1e7;
  }
  .tr-transform__scale-point {
  }

  .tr-transform__scale-point--tl {
    top: -7px;
    left: -7px;
  }

  .tr-transform__scale-point--ml {
    top: calc(50% - 7px);
    left: -7px;
  }

  .tr-transform__scale-point--tr {
    left: calc(100% - 7px);
    top: -7px;
  }

  .tr-transform__scale-point--tm {
    left: calc(50% - 7px);
    top: -7px;
  }

  .tr-transform__scale-point--mr {
    left: calc(100% - 7px);
    top: calc(50% - 7px);
  }

  .tr-transform__scale-point--bl {
    left: -7px;
    top: calc(100% - 7px);
  }

  .tr-transform__scale-point--bm {
    left: calc(50% - 7px);
    top: calc(100% - 7px);
  }

  .tr-transform__scale-point--br {
    background: #fff;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    position: absolute;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
    cursor: pointer;
    left: calc(100% - 7px);
    top: calc(100% - 7px);
  }
`;
export const RedDot = styled.div`
  height: 35px;
  width: 35px;
  border-radius: 50px;
  background-color: #c4342c;
  color: #fff;
  font-size: 15px;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(90deg);
  @media only screen and (min-width: 867px) {
    transform: rotate(0deg);
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
`;
export const BlueDot = styled.div`
  height: 35px;
  width: 35px;
  border-radius: 50px;
  background-color: blue;
  color: #fff;
  font-size: 15px;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(90deg);
  @media only screen and (min-width: 867px) {
    transform: rotate(0deg);
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
`;
export const BallDot = styled.div`
  position: absolute;
  height: 35px;
  width: 35px;
  border-radius: 50px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  background: url("/assets/Ball.png");
  background-size: cover;
  @media only screen and (min-width: 867px) {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
`;
export const WidgetContainer = styled.div`
  position: absolute;
  width: 35px;
  height: 35px;
  @media only screen and (min-width: 867px) {
    width: 50px;
    height: 50px;
  }
`;
export const AnimatorBarContainer = styled.div`
  width: 90%;
  flex-basis: 10%;
  height: calc(100% - 4px);
  background-color: #2a2a2a;
  margin: 0 1px 0 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid black;
  cursor: pointer;
  &#speedContainer {
    flex-basis: 20%;
    padding: 0 0.75rem;
  }
  img {
    width: 60%;
    transform: rotate(90deg);
  }
  @media only screen and (min-width: 867px) {
    height: calc(100% - 4px);
    flex-basis: 4%;
    &#speedContainer {
      flex-basis: 8%;
      padding: 0;
    }
    img {
      transform: inherit;
    }
  }
`;

export const DurationForm = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 100%;
  form {
    height: 90%;

    display: flex;
    flex-direction: column;
    input {
      width: 100%;
      margin: auto;
      background: transparent;
      color: white;
      font-size: 20px;
      font-weight: 700;
      border: none;
      text-align: center;
      transform: rotate(90deg);
    }
    button {
      background: #ff6a00;
      border-radius: 24px;
      border: none;
      color: white;
      padding: 0;
      font-size: 20px;
      font-weight: 700;
      cursor: pointer;
      transform: rotate(90deg);
    }
  }
  @media only screen and (min-width: 867px) {
    flex-direction: column;
    width: 90%;
    height: auto;
    form {
      margin: 0.5rem auto 0;
      display: grid;
      grid-template-columns: 25% 50% 25%;
      input {
        margin: 0 auto;
        transform: rotate(0deg);
        width: 50%;
        height: fit-content;
      }
      button {
        height: 25px;
        transform: rotate(0deg);
      }
    }
  }
`;
